import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { I } from "../../Components/CMI/icons";
import logo from "../../assets/cmi/logo_CE.png";

const items = [
  { id: "finanzas",  label: "Finanzas",     icon: I.Coin,      path: "/dashboard-finanzas" },
  { id: "finanzasV2", label: "Finanzas V2", icon: I.BarChart3, path: "/dashboard-finanzas-v2" },
  { id: "proyectos", label: "Proyectos",    icon: I.Briefcase, path: "/dashboard-proyectos" },
  { id: "marketing", label: "Marketing",    icon: I.Megaphone, path: "/dashboard-marketing" },
  { id: "social",    label: "Social Media", icon: I.Share,     path: "/dashboard-social-media", disabled: true },
];
const analysisItems = [
  { id: "ia",       label: "Automatización IA", icon: I.Sparkle,  path: "/dashboard-ia", badge: "5" },
  { id: "reportes", label: "Reportes",          icon: I.FileText, path: "/dashboard-reportes", disabled: true },
];
const ivghItems = [
  { id: "ivgh-dash",   label: "Dashboard IVGH", icon: I.BarChart3,  path: "/dashboard-ivgh" },
  { id: "ivgh-proy",   label: "Proyectos IVGH", icon: I.Briefcase,  path: "/ivgh-proyectos" },
  { id: "ivgh-hist",   label: "Histórico",      icon: I.Calendar,   path: "/ivgh-historico" },
  { id: "ivgh-config", label: "Config. IVGH",   icon: I.Settings,   path: "/ivgh-config" },
];

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = (() => {
    try { return JSON.parse(sessionStorage.getItem("authUser"))?.user || null; } catch { return null; }
  })();
  const initials = (user?.nombre || "Usuario").split(/\s+/).map(s => s[0]).slice(0, 2).join("").toUpperCase();

  const isActive = (path) => location.pathname === path || (path === "/dashboard-finanzas" && location.pathname === "/");

  const onLogout = () => {
    sessionStorage.removeItem("authUser");
    navigate("/login");
  };

  const renderItem = (it) => {
    const Ico = it.icon;
    const active = isActive(it.path);
    return (
      <div
        key={it.id}
        className={`sb-item ${active ? "active" : ""}`}
        onClick={() => !it.disabled && navigate(it.path)}
        style={it.disabled ? { opacity: 0.5, cursor: "not-allowed" } : {}}
      >
        <Ico size={18} />
        <span className="sb-label">{it.label}</span>
        {it.badge ? <span className="sb-badge">{it.badge}</span> : null}
      </div>
    );
  };

  return (
    <aside className="sb">
      <div className="sb-brand">
        <img src={logo} alt="Cucalón Estévez" />
      </div>
      <div className="sb-grp">Menú</div>
      {items.map(renderItem)}
      <div className="sb-spacer" />
      <div className="sb-grp">Análisis</div>
      {analysisItems.map(renderItem)}
      <div className="sb-grp">IVGH</div>
      {ivghItems.map(renderItem)}
      <div className="sb-spacer" />
      <div
        className={`sb-item ${location.pathname === "/dashboard-config" ? "active" : ""}`}
        onClick={() => navigate("/dashboard-config")}
      >
        <I.Settings size={18} />
        <span className="sb-label">Configuración</span>
      </div>
      <div className="sb-user">
        <div className="avatar">{initials}</div>
        <div className="sb-user-meta">
          <div className="name">{user?.nombre || "Usuario"}</div>
          <div className="mail">{user?.email || ""}</div>
        </div>
      </div>
      <div className="sb-logout" onClick={onLogout} title="Cerrar sesión">
        <I.LogOut size={16} />
        <span className="sb-label">Cerrar sesión</span>
      </div>
    </aside>
  );
};

export default Sidebar;
